export default __webpack_public_path__ + "static/ml-main-pic-0b7826c88962f8935ef4024557c8d9c7.png";